require("./theme-vendor");

jQuery(document).ready(function($) {

    // Handle external links confirmation
    $("a[target='_blank']").on('click', function(event) {
        if (!confirm("You are about to leave our website, continue?")) {
            event.preventDefault();
        }
    });

    /** =============================================================== **/
    /** Menu toggler  **/
    /** =============================================================== **/

    $('.hamburger').on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass('is-active');
    });

    /** =============================================================== **/
    /** Init Input masks **/
    /** =============================================================== **/

    $(".phone-mask").inputmask({
        "mask": "(999) 999-9999"
    });

    $(".zip-mask").inputmask({
        "mask": "99999",
        "placeholder": "",
    });

});

/** =============================================================== **/
/** Accessibility Improvements **/
/** =============================================================== **/

// Determine accessibility focus based on mouse/keyboard use
document.body.addEventListener('mousedown', function() {
    document.body.classList.add('using-mouse');
});
document.body.addEventListener('keydown', function() {
    document.body.classList.remove('using-mouse');
});